<template>
  <el-header class="admin-header visitor-header" height="110px">
    <div class="header-container">
      <router-link to="/">
        <div class="header-logo">
          <img src="@/assets/images/layouts/logo.png" alt="" />
        </div>
      </router-link>
      <div class="header-tabs">
        <a href="mailto:support@audiotestkitchen.com">
          <div class="tab-item">
            <span>SUPPORT</span>
          </div>
        </a>
      </div>
    </div>
    <div class="header-info">
      <div class="header-title">
        <span>ATK PLAYER ADMIN</span>
      </div>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'VisitorHeader',
  methods: {
  }
}
</script>

<style scoped lang="scss">
.visitor-header {
  padding: 0;
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 0 20px;
    background-color: $theme;
    .header-logo {
      img {
        height: 40px;
      }
    }
    .header-tabs {
      display: flex;
      color: white;
      font-size: 14px;
      a {
        color: white;
        text-decoration: none;
      }
      .tab-item {
        margin-right: 60px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .header-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 10px 20px;
    border-bottom: solid 2px $theme_light;
    .header-title {
      font-weight: bold;
      font-size: 30px;
      line-height: 40px;
      letter-spacing: -1px;
    }
  }
}
</style>
